import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { RialSign } from "@/components/RialSign";
import { useAuth } from "@/context/AuthContext";
import { applyBrand, setTitle } from "@/lib/pwa";
import { InstallButton } from "@/components/pwa/InstallButton";
import { BrainLogo, LoginBackdrop } from "@/components/login/LoginShell";
import { LoginCard } from "@/components/login/LoginCard";
import { homeFor } from "@/pages/BrandedLoginPage";

export default function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useEffect(() => { applyBrand(null); setTitle(null, "Sign in"); }, []);
  if (user) return <Navigate to={homeFor(user)} replace />;
  const done = (u) => { localStorage.removeItem("pnl_login_slug"); navigate(homeFor(u), { replace: true }); };

  return (
    <div className="relative isolate flex min-h-[100dvh] flex-col items-center justify-center px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))]" data-testid="login-page">
      <LoginBackdrop />
      <div className="absolute right-4 top-[max(1rem,env(safe-area-inset-top))]"><InstallButton dark /></div>
      <div className="rise-in flex w-full max-w-md flex-col items-center gap-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <BrainLogo className="h-24 w-24 sm:h-32 sm:w-32" />
          <div className="text-xl font-bold tracking-tight text-white sm:text-2xl">THE BRAIN</div>
          <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-teal-300/90">Profit &amp; Loss · Tasks · Approvals</div>
        </div>
        <LoginCard title={<h1 className="text-2xl font-bold tracking-tight sm:text-3xl">Sign in</h1>} subtitle="Platform administration"
          footer="Access is restricted to administrators." onSignedIn={done} />
        <p className="text-xs text-slate-400">All amounts in Omani Rial (<RialSign className="!mr-0" />)</p>
      </div>
    </div>
  );
}
